import Ribbon from './modules/ribbon.js';

document.addEventListener('DOMContentLoaded', () => {
	const observer = new MutationObserver(() => {
		if (document.querySelector('.owl-item')) {
			Ribbon.moveAll();
			observer.disconnect();
		}
	});

	observer.observe(document.body, {
		childList: true,
		subtree: true,
	});
});
